import { FILE_NAME_SAVE } from '../constants/fileNameConstants';

export function saveFileName(fileName) {
	return {
		type: FILE_NAME_SAVE,
		payload: { fileName }
	};
}
